import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String
  }

  connect() {
    if (!this.onboardingUrlValue) return

    this.initWidget()
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: "fr",
        onMyAccount: () => this.redirectToNextStep(false),
        onFinish: () => this.redirectToNextStep(true),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    )
  }

  redirectToNextStep(onboardingSubmitted = false) {
    const url = new URL(this.redirectUrlValue)
    if (onboardingSubmitted) {
      url.searchParams.set("onboarding_submitted", "true")
    }

    window.location.replace(url)
  }
}
